import { colors } from 'design-system';
// Redux
import { connect, ConnectedProps } from 'react-redux';
import { setFilterMenuUnderstood } from 'src/store/notification/actions';
import { RootState } from 'src/store/rootReducer';
// Components
import { InformationPopper } from 'src/components/General';
import { FilterIcon } from 'src/components/Icons';

export const FilterPopper = ({
  filterUnderstood,
  setFilterMenuUnderstoodAction,
}: Props): JSX.Element => {
  return (
    <InformationPopper
      data-testid="filter-popper-component"
      information="Encuentra aquí filtros para mostrar las pólizas según su estado."
      onUnderstood={setFilterMenuUnderstoodAction}
      title="Filtros para pólizas y cotizaciones"
      open={!filterUnderstood}
      rightContentAlign={-150}
    >
      <FilterIcon strokeWidth="2px" color={colors.bright_turquoise} />
    </InformationPopper>
  );
};

export const mapStateToProps = (
  state: RootState,
): {
  filterUnderstood: boolean;
} => ({
  filterUnderstood: state.notification.filterUnderstood,
});

const reduxActions = {
  setFilterMenuUnderstoodAction: setFilterMenuUnderstood,
};

const connector = connect(mapStateToProps, reduxActions);
type Props = ConnectedProps<typeof connector>;

export default connector(FilterPopper);
